import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import StrategySession from "./pages/StrategySession";
import OngoingSupport from "./pages/OngoingSupport";
import HowWeBuild from "./pages/HowWeBuild";
import Admin from "./pages/Admin";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/strategy-session" element={<StrategySession />} />
          <Route path="/ongoing-support" element={<OngoingSupport />} />
          <Route path="/how-we-build" element={<HowWeBuild />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
